import { ChainId } from 'apertum-dex-sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: `${process.env.REACT_APP_MULTICALL_MAINNET_ADDRESS}`, // MAINNET
  [ChainId.GÖRLI]: `${process.env.REACT_APP_MULTICALL_ADDRESS}`,           // HARDHAT
  [ChainId.ROPSTEN]: `${process.env.REACT_APP_MULTICALL_TESTNET_ADDRESS}`, // TESTNET
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
